import { SVGFC } from '@repo/toolkit/types'

const EllipsisIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="3"
      height="14"
      viewBox="0 0 3 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.5 2.84375C1.86244 2.84375 2.15625 2.54994 2.15625 2.1875C2.15625 1.82506 1.86244 1.53125 1.5 1.53125C1.13756 1.53125 0.84375 1.82506 0.84375 2.1875C0.84375 2.54994 1.13756 2.84375 1.5 2.84375Z"
        stroke={color}
        strokeWidth="1.3125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 7.65576C1.86244 7.65576 2.15625 7.36195 2.15625 6.99951C2.15625 6.63707 1.86244 6.34326 1.5 6.34326C1.13756 6.34326 0.84375 6.63707 0.84375 6.99951C0.84375 7.36195 1.13756 7.65576 1.5 7.65576Z"
        stroke={color}
        strokeWidth="1.3125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 12.4683C1.86244 12.4683 2.15625 12.1744 2.15625 11.812C2.15625 11.4496 1.86244 11.1558 1.5 11.1558C1.13756 11.1558 0.84375 11.4496 0.84375 11.812C0.84375 12.1744 1.13756 12.4683 1.5 12.4683Z"
        stroke={color}
        strokeWidth="1.3125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default EllipsisIcon
